// eslint-disable-next-line no-unused-vars
import { ServerStackIcon, Battery0Icon, SignalSlashIcon, ClockIcon, DevicePhoneMobileIcon, Battery50Icon, PhotoIcon, MapIcon, BoltIcon, FireIcon, KeyIcon, ServerIcon, SignalIcon, HashtagIcon, LightBulbIcon, MapPinIcon, XMarkIcon, Bars3Icon, Squares2X2Icon, BarsArrowUpIcon, BarsArrowDownIcon, Bars4Icon, SunIcon } from '@heroicons/vue/24/solid';

export const STANDARD_VIEWS = [
	{ id: 'all', label: 'All Devices', label_translation_key: 'operator_mode.all_devices', icon: ServerStackIcon, filters: undefined },

	{
		id: 'continuity',
		label: 'Missing Continuity',
		// label_translation_key: 'operator_mode.continuity',
		icon: SunIcon,
		filters: [{ 'field': 'continuity_statuses', 'condition': ['%MISSING%', '%NOT_IN_SCRIPT%'], 'comparator': 'like' }],
		display_settings: {
			'layout': 'grid',
			'group_by': 'device_type',
			'order_by': 'no_ordering',
			'use_compact_ui': false,
			'order_direction': 'asc',
			'fields_to_display': ['continuity', 'channel', 'image', 'device_type', 'address', 'key_position', 'device_state'],
			'show_empty_groups': false,
		},
	},
	{
		id: 'position',
		label: 'Position',
		// label_translation_key: 'operator_mode.low_signal',
		icon: MapPinIcon,
		filters: null,
		display_settings: {
			'layout': 'grid',
			'group_by': 'position',
			'order_by': 'no_ordering',
			'use_compact_ui': false,
			'order_direction': 'asc',
			'fields_to_display': ['address', 'battery_1_level', 'battery_2_level', 'voltage_mode', 'key_position', 'signal_strength', 'dmx_universe', 'position', 'channel', 'continuity', 'device_type', 'image', 'device_state', 'firing_mode'],
			'show_empty_groups': false,
		},
	},
	{
		id: 'signal',
		label: 'Signal',
		// label_translation_key: 'operator_mode.low_signal',
		icon: SignalIcon,
		filters: null,
		'display_settings': {
			'layout': 'grid',
			'group_by': 'no_grouping',
			'order_by': 'signal_strength',
			'use_compact_ui': false,
			'order_direction': 'desc',
			'fields_to_display': ['address', 'device_type', 'image', 'position', 'continuity', 'channel', 'signal_strength', 'device_state', 'key_position'],
			'show_empty_groups': false,
		},
	},
	{
		id: 'power',
		label: 'Power',
		// label_translation_key: 'operator_mode.low_signal',
		icon: BoltIcon,
		filters: null,
		'display_settings': {
			'layout': 'grid',
			'group_by': 'no_grouping',
			'order_by': 'battery_levels',
			'use_compact_ui': false,
			'order_direction': 'asc',
			'fields_to_display': ['address', 'battery_1_level', 'battery_2_level', 'device_type', 'image', 'voltage_mode', 'firing_mode', 'key_position', 'position', 'continuity', 'device_state', 'channel'],
			'show_empty_groups': false,
		},
	},
	// {
	// 	id: 'low_battery',
	// 	label: 'Low Battery',
	// 	label_translation_key: 'operator_mode.low_battery',
	// 	icon: Battery0Icon,
	// 	filters: [
	// 		{
	// 			comparator: 'or',
	// 			condition: [
	// 				{
	// 					field: 'battery_1_level',
	// 					comparator: 'lte',
	// 					condition: 4,
	// 				},
	// 				{
	// 					field: 'battery_2_level',
	// 					comparator: 'lte',
	// 					condition: 4,
	// 				},
	// 			],
	// 		},
	// 	],
	// },
	// {
	// 	id: 'low_signal',
	// 	label: 'Low Signal',
	// 	label_translation_key: 'operator_mode.low_signal',
	// 	icon: SignalSlashIcon,
	// 	filters: [
	// 		{
	// 			field: 'signal_strength',
	// 			comparator: 'lte',
	// 			condition: -75,
	// 		},
	// 	],
	// },
];

export const STANDARD_VIEWS_ID_ARRAY = ['all', 'position', 'signal', 'power'];

export const AVAILABLE_SHOW_OPERATOR_DISPLAY_SETTINGS = {
	layout: [
		{ id: 'grid', label: 'Grid', icon: Squares2X2Icon, is_default: true },
		{ id: 'list', label: 'List', icon: Bars3Icon },
	],
	group_by: [
		{ id: 'device_type', label: 'Device Type', icon: DevicePhoneMobileIcon, is_default: true },
		{ id: 'voltage_mode', label: 'Voltage Mode', icon: BoltIcon },
		{ id: 'firing_mode', label: 'Firing Mode', icon: FireIcon },
		{ id: 'key_position', label: 'Key Position', icon: KeyIcon },
		{ id: 'device_state', label: 'Device State', icon: ServerIcon },
		{ id: 'position', label: 'Position', icon: MapPinIcon },
		// { id: 'channel', label: 'Channel', icon: HashtagIcon },
		{ id: 'no_grouping', label: 'No Grouping', icon: XMarkIcon },
	],
	order_by: [
		{ id: 'address', label: 'Address', icon: MapIcon },
		{ id: 'device_type', label: 'Device Type', icon: DevicePhoneMobileIcon },
		{ id: 'voltage_mode', label: 'Voltage Mode', icon: BoltIcon },
		{ id: 'firing_mode', label: 'Firing Mode', icon: FireIcon },
		{ id: 'key_position', label: 'Key Position', icon: KeyIcon },
		{ id: 'device_state', label: 'Device State', icon: ServerIcon },
		{ id: 'signal_strength', label: 'Signal Strength', icon: SignalIcon },
		{ id: 'battery_levels', label: 'Battery Levels', icon: Battery50Icon },
		// { id: 'position', label: 'Position', icon: MapPinIcon },
		// { id: 'channel', label: 'Channel', icon: HashtagIcon },
		{ id: 'no_ordering', label: 'No Sorting', icon: XMarkIcon, is_default: true },
	],
	order_direction: [
		{ id: 'asc', label: 'Ascending', icon: BarsArrowUpIcon, is_default: true },
		{ id: 'desc', label: 'Descending', icon: BarsArrowDownIcon },
	],
	fields_to_display: [
		{ id: 'image', label: 'Image', icon: PhotoIcon, is_default: true },
		{ id: 'device_type', label: 'Device Type', icon: DevicePhoneMobileIcon, is_default: true },
		{ id: 'address', label: 'Address', icon: MapIcon, is_default: true },
		{ id: 'battery_1_level', label: 'Battery 1 Level', icon: Battery50Icon, is_default: true },
		{ id: 'battery_2_level', label: 'Battery 2 Level', icon: Battery50Icon, is_default: true },
		{ id: 'voltage_mode', label: 'Voltage Mode', icon: BoltIcon, is_default: true },
		{ id: 'firing_mode', label: 'Firing Mode', icon: FireIcon, is_default: true },
		{ id: 'key_position', label: 'Key Position', icon: KeyIcon, is_default: true },
		{ id: 'device_state', label: 'Device State', icon: ServerIcon, is_default: false },
		{ id: 'signal_strength', label: 'Signal Strength', icon: SignalIcon, is_default: true },
		{ id: 'dmx_universe', label: 'DMX Universe', icon: LightBulbIcon, is_default: true },
		{ id: 'position', label: 'Position', icon: MapPinIcon, is_default: true },
		{ id: 'channel', label: 'Channel', icon: HashtagIcon, is_default: true },
		// { id: 'bank', label: 'Bank', icon: undefined, is_default: true },
		{ id: 'continuity', label: 'Continuity', icon: SunIcon, is_default: true },
	],
};

export const DEFAULT_SHOW_OPERATOR_DISPLAY_SETTINGS = {
	layout: 'grid',
	group_by: 'device_type',
	order_by: 'no_ordering',
	use_compact_ui: false,
	order_direction: 'asc',
	fields_to_display: ['image', 'device_type', 'address', 'battery_1_level', 'battery_2_level', 'voltage_mode', 'firing_mode', 'key_position', 'signal_strength', 'dmx_universe', 'position', 'channel', 'continuity'],
	show_empty_groups: false,
};

export const STANDARD_EVENT_LIST_VIEWS = [
	{ id: 'all_controls', label: 'All Events', label_translation_key: 'operator_mode.controls.all_events', icon: ServerStackIcon, filters: undefined, view_type: 'controls' },
	// {
	// 	id: 'upcoming_events_controls',
	// 	label: 'Upcoming Events',
	// 	// label_translation_key: 'operator_mode.controls.all_events',
	// 	icon: ClockIcon,
	// 	filters: [
	// 		{ 'field': 'pryo_playback_statuses', 'condition': ['%FIRED%'], 'comparator': 'like' },
	// 		{ 'field': 'dmx_playback_statuses', 'condition': ['%FIRED%'], 'comparator': 'like' },
	// 	],
	// 	view_type: 'controls'
	// },
];

export const TIMER_TYPES = ['CONTINUOUS_CLOCK', 'ELAPSED_TIME', 'COUNTDOWN_TO_TIME', 'COUNTDOWN'];

export const EPSILON_FOR_PAUSED_ON_STEP = 3;
